"use client";

import { UsdtIcon } from "@/components/icons";
import { InfoCard } from "@/components/ui/info-card";
import { SkeletonElement } from "@/components/ui/skeleton";
import { useUserStats, useDevice } from "@/hooks";
import { formatStatValue } from "@/utils/general";

export const ProfileMetrics = () => {
  const { stats, isLoading } = useUserStats();
  const { isMobile } = useDevice();

  const metrics = [
    {
      title: "Total Earned",
      value: stats?.totalVolumeRewarded?.value || 0,
      isMoney: true,
      showUsdtIcon: true,
    },
    {
      title: "Total Volume Traded",
      value: stats?.totalVolumeTraded?.value || 0,
      isMoney: true,
      showUsdtIcon: false,
    },
    {
      title: "Total Trades",
      value: stats?.tradesDone?.value || 0,
      isMoney: false,
      showUsdtIcon: false,
    },
  ];

  return (
    <div className="flex w-full flex-col gap-3.5 lg:flex-row">
      {metrics.map((metric) => (
        <InfoCard
          key={metric.title}
          title={metric.title}
          padding={isMobile ? "none" : "md"}
          withBackground={!isMobile}
          withBorder={!isMobile}
          gap="sm"
          className="flex-1"
          contentClassName="flex flex-col"
          titleClassName="text-md font-semibold text-cede-text-primary"
        >
          <div className="text-[21px] font-bold leading-[140%] text-cede-text-accent flex items-center gap-1">
            {isLoading ? (
              <SkeletonElement className="h-6 w-24 rounded-md" />
            ) : metric.showUsdtIcon ? (
              <>
                <UsdtIcon width={20} height={20} className="shrink-0" />
                {formatStatValue(metric.value, true).replace(/^\$/, "")}
              </>
            ) : (
              formatStatValue(metric.value, metric.isMoney)
            )}
          </div>
        </InfoCard>
      ))}
    </div>
  );
};
